import {ref} from '@vue/composition-api';

const useDomain = () => {
    
    const code = ref(null)
    const wrongCode = ref(false)

    const setCode = val => code.value = val

    const confirmCode = (emailCode) =>  {
        wrongCode.value = false
        if(emailCode === code.value) {
            return true
        } 
        wrongCode.value = true
    }

    return {
        code,
        setCode,
        wrongCode,
        confirmCode   
    }
}

export default useDomain